import React from "react";
import { useNavigate } from "react-router-dom"; 
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import footerBg from "../assets/images/footer-new.png";
import logo from "../assets/images/head.png";

export default function Footer() {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 150);
  };

  const goTopLink = (path) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 150);
  };

  return (
    <footer className="relative w-full overflow-hidden">

      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-cover"
        style={{ backgroundImage: `url(${footerBg})` }}
      ></div>

      <div className="absolute inset-0 bg-black/60"></div>

      <div className="relative max-w-7xl mx-auto px-10 py-20 grid grid-cols-1 md:grid-cols-3 gap-12 text-white">

        <div>
          <h3 className="text-xl font-semibold mb-6">Quick Links</h3>

          <ul className="space-y-2 text-white/90">

            <li>
              <button onClick={goHome} className="hover:underline underline-offset-4 transition-all">
                Home
              </button>
            </li>

            <li>
              <button onClick={() => goTopLink("/tea")} className="hover:underline underline-offset-4 transition-all">
                Tea
              </button>
            </li>

            <li>
              <button onClick={() => goTopLink("/coconut")} className="hover:underline underline-offset-4 transition-all">
                Coconut
              </button>
            </li>

            <li>
              <button onClick={() => goTopLink("/spices")} className="hover:underline underline-offset-4 transition-all">
                Spices
              </button>
            </li>

            <li>
              <button onClick={() => goTopLink("/rice")} className="hover:underline underline-offset-4 transition-all">
                Rice
              </button>
            </li>

            <li>
              <button onClick={() => goTopLink("/products")} className="hover:underline underline-offset-4 transition-all">
                Products
              </button>
            </li>

            <li>
              <button onClick={() => goTopLink("/contact")} className="hover:underline underline-offset-4 transition-all">
                Contact Us
              </button>
            </li>

          </ul>
        </div>

        <div>
          <h3 className="text-xl font-semibold mb-6">Contact Us</h3>

          <p className="text-white/90 leading-relaxed">
            CEYMOS LANKA (PVT) LTD <br />
            270H,Dickland Watta, <br />
            Hokandara Rd, <br />
            Thalawathugoda <br />
            Sri Lanka
          </p>

          <p className="mt-4 text-white/90">+94 77 195 5100</p>

          <a
            href="mailto:ceymos.lanka@gmail.com"
            className="text-white/90 hover:underline underline-offset-4 block mt-2"
          >
            ceymos.lanka@gmail.com
          </a>
        </div>

        <div className="text-center md:text-left">
          <img src={logo} alt="Ceymos Logo" className="w-28 mb-6 mx-auto md:mx-0" />

          <h3 className="text-xl font-semibold mb-6">Follow Us</h3>

          <div className="flex space-x-4 justify-center md:justify-start">

            <a
              href="https://web.facebook.com/people/Ceymos-Lanka/61576319648785/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-white flex items-center justify-center
                         hover:bg-white hover:text-black transition"
            >
              <FaFacebookF size={18} />
            </a>

            <a
              href="https://www.instagram.com/ceymoslanka/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-white flex items-center justify-center
                         hover:bg-white hover:text-black transition"
            >
              <FaInstagram size={18} />
            </a>

          </div>
        </div>
      </div>

      <div className="relative text-center text-white/80 text-sm py-6">
        Copyright © {new Date().getFullYear()} 
        CEYMOS LANKA — All Rights Reserved
      </div>

    </footer>
  );
}
